import { passkeyClient } from "@better-auth/passkey/client";
import {
	adminClient,
	inferAdditionalFields,
	magicLinkClient,
	organizationClient,
	twoFactorClient,
} from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import type { auth } from ".";

type AuthClientOptions = Omit<
	NonNullable<Parameters<typeof createAuthClient>[0]>,
	"plugins"
>;

/**
 * Creates an auth client with the app's plugin set. The app uses the default
 * instance below; integration tests create their own with an in-process fetch.
 */
export function createAppAuthClient(options: AuthClientOptions = {}) {
	return createAuthClient({
		...options,
		plugins: [
			inferAdditionalFields<typeof auth>(),
			magicLinkClient(),
			organizationClient(),
			adminClient(),
			passkeyClient(),
			twoFactorClient(),
		],
	});
}

export const authClient = createAppAuthClient();

export type AuthClientErrorCode =
	| keyof typeof authClient.$ERROR_CODES
	| "INVALID_INVITATION"
	| "NOT_ALLOWED_WHILE_IMPERSONATING"
	// Returned by the passkey client when the browser prompt is cancelled.
	| "ERROR_CEREMONY_ABORTED"
	| "ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY";

/** Maps each error code the auth API can return to a message. */
export type AuthClientErrorCodes = Record<AuthClientErrorCode, string>;
